import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { RootState } from 'modules';
import InterestedMentor from 'components/mentoring/mentee/InterestedMentor';
import MenteeUpcomingClass from 'components/mentoring/mentee/MenteeUpcomingClass';
import MentoringPastClass from 'components/mentoring/MentoringPastClass';
import { ProfileWrapper, MentoringClassWrapper } from 'components/mentoring/styles';
import { getCreditBalance } from 'libs/api/user';
import { useDataApi, usePagination } from 'libs/hooks';
import { CURRENT_TICKET_BALANCE, CURRENT_FINANCE_TICKET_BALANCE } from 'modules/mentoring';
import { TUser } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { CUserType } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Tabs, Button, Col, Row, Typography, Tag } from 'antd';
import styled from 'styled-components';
import { MenteeColor, PrimaryColor, SecondaryColor, device } from 'GlobalStyles';

const { TabPane } = Tabs;
const { Text, Title } = Typography;

const MenteeMyPage = ({ user }: { user: TUser | undefined }) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  //좌상단 탭 이동에 따라 쿼리 파라미터로 consulting, finance 구분해서 balance 데이터 받음
  const getPromise = getCreditBalance.bind(null, {
    field: {
      mentoring_field: currentUser?.primary_field,
    },
  });
  const [{ data: creditBalance }] = useDataApi<{ [key: string]: string }>(getPromise.bind(null));
  // const [{ data: creditBalance }] = useDataApi<{ [key: string]: string }>(getCreditBalance.bind(null));
  const [key, setKey] = useState('upcoming');

  return (
    <MentoringClassWrapper>
      <Row
        style={{
          maxWidth: `${CWindowWidth - 300}px`,
          margin: '20px auto',
          padding: '30px 10px',
        }}
        gutter={[32, 16]}
      >
        <Col
          xs={{ span: 24, order: 2 }}
          sm={{ span: 24, order: 2 }}
          md={{ span: 16, order: 1 }}
          lg={{ span: 16, order: 1 }}
          xl={{ span: 17, order: 1 }}
        >
          <Title level={2} style={{ marginBottom: '0px' }}>
            나의 멘토링 관리
          </Title>
          <Tabs
            style={{ marginTop: '20px' }}
            activeKey={key}
            onChange={(e) => {
              setKey(e);
            }}
          >
            <TabPane tab='다가오는 멘토링' key='upcoming'>
              <MenteeUpcomingClass />
            </TabPane>
            <TabPane tab='지난 멘토링' key='past'>
              <MentoringPastClass targetType={EUserType.Mentor} useDivider={true} />
            </TabPane>
            <TabPane tab='찜한 멘토' key='interested'>
              <InterestedMentor />
            </TabPane>
          </Tabs>
        </Col>
        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 7, offset: 1 }}
          lg={{ span: 7, offset: 1 }}
          xl={{ span: 6, offset: 1 }}
          style={{ textAlign: 'center' }}
        >
          <div className='border-box'>
            <ProfileWrapper style={{ maxWidth: '190px' }}>
              <Link to={`${ERoute.UserEdit}`}>
                <img alt='profile_image' src={get(user, 'profile_image.absolute_url')} />
              </Link>
              <Tag className='user-type-tag' color={MenteeColor}>
                {CUserType[EUserType.Mentee]}
              </Tag>
            </ProfileWrapper>
            <div style={{ textAlign: 'left' }}>
              <StyledCurrentTicketsTitle>{get(user, 'fullname')} 님의 보유 수강권</StyledCurrentTicketsTitle>
              <StyledCurrentTickets
                style={{
                  color: SecondaryColor,
                }}
              >
                {creditBalance ? (
                  Object.values(creditBalance).every((value) => !Number(value)) ? (
                    <div> 보유한 수강권이 없습니다. </div> //creditBalance 객체의 value 값들이 모두 0이면
                  ) : (
                    <>
                      {currentUser?.primary_field === EMentoringField.Consulting &&
                        CURRENT_TICKET_BALANCE.map((el: { ticket_name: string; key_name: string }) => (
                          <div>
                            {Number(creditBalance[el.key_name]) > 0
                              ? `${el.ticket_name} : ${Number(creditBalance[el.key_name])}회`
                              : ''}
                          </div>
                        ))}
                      {currentUser?.primary_field === EMentoringField.Finance &&
                        CURRENT_FINANCE_TICKET_BALANCE.map(
                          (el: { ticket_name: string; key_name: string }) => (
                            <div>
                              {Number(creditBalance[el.key_name]) > 0
                                ? `${el.ticket_name} : ${Number(creditBalance[el.key_name])}회`
                                : ''}
                            </div>
                          ),
                        )}
                    </>
                  )
                ) : (
                  <div> 보유한 수강권이 없습니다. </div>
                )}
              </StyledCurrentTickets>
            </div>
            <Row justify='space-between' gutter={[0, 16]} style={{ marginTop: '2px' }}>
              <Col>
                <Link to={`${ERoute.MentoringMentorList}`}>
                  <Button className='large-btn' type='primary'>
                    멘토링 신청
                  </Button>
                </Link>
              </Col>
              <Col>
                <Link to={`${ERoute.MentoringCreditPrice}`}>
                  <Button className='large-btn'>수강권 구매</Button>
                </Link>
              </Col>
            </Row>
          </div>
          <div style={{ padding: '10px' }}> </div>
          <div className='border-box' style={{ borderColor: '#3CAC40', padding: '30px' }}>
            <div style={{ textAlign: 'center' }}>
              <StyledBannerTitle>전략 컨설팅 인터뷰</StyledBannerTitle>
              <StyledBannerTitle>MasterClass [기초편]</StyledBannerTitle>
              <StyledBannerTitle>온라인 강의가</StyledBannerTitle>
              <StyledBannerTitle>새롭게 출시되었어요</StyledBannerTitle>
              <div style={{ padding: '10px' }}> </div>
              <StyledBannerText
                style={{
                  color: 'grey',
                }}
              >
                전략컨설팅 준비 Day 1부터
              </StyledBannerText>
              <StyledBannerText
                style={{
                  color: 'grey',
                }}
              >
                인터뷰 전까지 과정에서
              </StyledBannerText>
              <StyledBannerText
                style={{
                  color: 'grey',
                }}
              >
                익혀야 할 모든 내용을 담은
              </StyledBannerText>
              <StyledBannerText
                style={{
                  color: 'grey',
                }}
              >
                풀 패키지 VOD 강의입니다
              </StyledBannerText>
            </div>
            <div style={{ padding: '10px' }}> </div>
            <Link to={`${ERoute.LectureInterviewMasterClassBasic}`}>
              <Button className='large-btn' type='primary'>
                자세히 알아보기
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </MentoringClassWrapper>
  );
};

export default MenteeMyPage;

const StyledCurrentTicketsTitle = styled.div`
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 3px;
  @media screen and ${device.lg} {
    font-size: 16px;
  }
`;

const StyledCurrentTickets = styled.div`
  padding: 5px 0;
  font-size: 14px;
  @media screen and ${device.lg} {
    font-size: 12px;
  }
`;

const StyledBannerTitle = styled.div`
  font-size: 16px;
  font-weight: bolder;
  margin-bottom: 0px;
  @media screen and ${device.lg} {
    font-size: 14px;
  }
`;

const StyledBannerText = styled.div`
  font-size: 14px;
  margin-bottom: 0px;
  @media screen and ${device.lg} {
    font-size: 12px;
  }
`;
